module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-grid-22463dc1c36cc9a7c866b2b0b49d83c0.svg";